// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/gorditaregular-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/gorditamedium-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/gorditabold-webfont.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: "Gordita", Arial, sans-serif;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
}

html,
body,
#root {
  overscroll-behavior-y: none;
  -webkit-overscroll-behavior-y: none;
  -ms-overscroll-behavior-y: none;
  height: 100%;
}

#app {
  height: 100%;
}

body {
  margin: 0;
  padding: 0;
}

body,
h1,
h2,
h3,
p,
span {
  font-weight: normal;
}

#root {
  display: flex;
  flex-direction: column;
}
#contentWrapper {
  flex: 1 0 auto;
}

@font-face {
  font-family: "gordita";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
  font-weight: 500;
  font-style: regular;
} /*!sc*/

@font-face {
  font-family: "gordita";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"),
    url("https://www.originenergy.com.au/static/tal-client/fonts/gordita/gorditamedium-webfont.woff")
      format("woff");
  font-weight: 600;
  font-style: medium;
} /*!sc*/

@font-face {
  font-family: "gordita";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"),
    url("https://www.originenergy.com.au/static/tal-client/fonts/gordita/gorditabold-webfont.woff")
      format("woff");
  font-weight: 700;
  font-style: bold;
} /*!sc*/

body {
  background: #f1f1f1;
}
`, "",{"version":3,"sources":["webpack://./public/style.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;;;EAGE,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,2DAAsE;EACtE,gBAAgB;EAChB,mBAAmB;AACrB,EAAE,MAAM;;AAER;EACE,sBAAsB;EACtB;;oBAEkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB,EAAE,MAAM;;AAER;EACE,sBAAsB;EACtB;;oBAEkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB,EAAE,MAAM;;AAER;EACE,mBAAmB;AACrB","sourcesContent":["* {\n  font-family: \"Gordita\", Arial, sans-serif;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n}\n\nhtml,\nbody,\n#root {\n  overscroll-behavior-y: none;\n  -webkit-overscroll-behavior-y: none;\n  -ms-overscroll-behavior-y: none;\n  height: 100%;\n}\n\n#app {\n  height: 100%;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n}\n\nbody,\nh1,\nh2,\nh3,\np,\nspan {\n  font-weight: normal;\n}\n\n#root {\n  display: flex;\n  flex-direction: column;\n}\n#contentWrapper {\n  flex: 1 0 auto;\n}\n\n@font-face {\n  font-family: \"gordita\";\n  src: url(\"./assets/fonts/gorditaregular-webfont.woff2\") format(\"woff\");\n  font-weight: 500;\n  font-style: regular;\n} /*!sc*/\n\n@font-face {\n  font-family: \"gordita\";\n  src: url(\"./assets/fonts/gorditamedium-webfont.woff2\") format(\"woff2\"),\n    url(\"https://www.originenergy.com.au/static/tal-client/fonts/gordita/gorditamedium-webfont.woff\")\n      format(\"woff\");\n  font-weight: 600;\n  font-style: medium;\n} /*!sc*/\n\n@font-face {\n  font-family: \"gordita\";\n  src: url(\"./assets/fonts/gorditabold-webfont.woff2\") format(\"woff2\"),\n    url(\"https://www.originenergy.com.au/static/tal-client/fonts/gordita/gorditabold-webfont.woff\")\n      format(\"woff\");\n  font-weight: 700;\n  font-style: bold;\n} /*!sc*/\n\nbody {\n  background: #f1f1f1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
